export default {"src":"/_next/static/media/chatBubbleWithList_24.b188afb5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};